/* eslint-disable */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import {
  filterFns,
  flexRender,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import PropTypes from "prop-types";
import { useMemo, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { utils, writeFile } from "xlsx";
// import { CSVLink } from "react-csv";
import { handleLoading, useLoading } from "context/LoadingContext";
import { useReactToPrint } from "react-to-print";
import { fullDateWithDetails } from "utils/returnDate";
import TableReportDataPeriod from "./TableReportDataPeriod";
import { generateTextFromJson } from "utils/generateTextFromJson";
import addNewLog from "utils/addNewLog";
import { useAuth } from "context/auth";

function getNotIntersection(array1, array2) {
  return array1
    .filter((value) => !array2.includes(value))
    .concat(array2.filter((value) => !array1.includes(value)));
}
// const pageSizes = [10, 20, 30, 40, 50];

/**
 * 
   column option to disable filter  : enableColumnFilter: false
   my custom filterFn : datePeriod , customEqual (you can add new custom fitters at filterFn object)
    filterInputInfo: {
          type: "date", "select" , "number" , "numberPeriod"
          if select => options: []
      },

 */

function Filter({ column, headers }) {
  const columnFilterValue = column.getFilterValue();
  const extraProcess = column.columnDef?.filterInputInfo?.extraProcess;
  const filterRef = useRef();
  if (!column.getCanFilter() || !column.columnDef?.filterInputInfo) return null;
  if (
    !column.columnDef?.filterInputInfo?.type ||
    column.columnDef?.filterInputInfo?.type === "string"
  )
    return (
      <Form.Group
        className="input input-md"
        controlId={column.columnDef.header}
      >
        <Form.Label>
          {column.columnDef?.filterInputInfo?.label || column.columnDef.header}
        </Form.Label>
        <Form.Control
          ref={filterRef}
          type="text"
          value={columnFilterValue || ""}
          onChange={(e) => {
            column.setFilterValue(e.target.value);
          }}
        />
      </Form.Group>
    );
  if (column.columnDef?.filterInputInfo?.type === "select") {
    const selectOptions = column.columnDef?.filterInputInfo?.selectOptions;
    return (
      <Form.Group className="input input-md" controlId="">
        <Form.Label>
          {column.columnDef?.filterInputInfo?.label || column.columnDef.header}
        </Form.Label>
        <Form.Select
          onChange={(e) => {
            column.setFilterValue(e.target.value);
            if (extraProcess)
              extraProcess({
                column,
                headers,
                filterRef,
                newValue: e.target.value,
              });
          }}
          value={columnFilterValue || ""}
          // multiple="multiple"
        >
          <option value="">الرجاء الاختيار</option>
          {column.columnDef?.filterInputInfo?.options.map((option) => (
            <option
              key={option[selectOptions.value]}
              value={option[selectOptions.value]}
            >
              {option[selectOptions.name]}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    );
  }
  if (
    !column.columnDef?.filterInputInfo?.type ||
    column.columnDef?.filterInputInfo?.type === "number"
  )
    return (
      <Form.Group
        className="input input-md"
        controlId={column.columnDef.header}
      >
        <Form.Label>
          {column.columnDef?.filterInputInfo?.label || column.columnDef.header}
        </Form.Label>
        <Form.Control
          ref={filterRef}
          type="number"
          value={columnFilterValue || ""}
          onChange={(e) => {
            column.setFilterValue(
              e.target.value ? parseInt(e.target.value, 10) : null
            );
            if (extraProcess)
              extraProcess({
                column,
                headers,
                filterRef,
                newValue: e.target.value,
              });
          }}
        />
      </Form.Group>
    );
  if (column.columnDef?.filterInputInfo?.type === "date")
    return (
      <div className="table__filter__period">
        <Form.Group
          className="input input-md date-input"
          controlId={`${column.columnDef.header}-from`}
        >
          <Form.Label>
            {column.columnDef?.filterInputInfo?.label ||
              column.columnDef.header}{" "}
            من
          </Form.Label>
          <Form.Control
            ref={filterRef}
            type="date"
            value={columnFilterValue?.[0] || ""}
            onChange={(e) => {
              column.setFilterValue((old) => [e.target.value, old?.[1] || ""]);
              if (extraProcess)
                extraProcess({
                  column,
                  headers,
                  filterRef,
                  newValue: e.target.value,
                });
            }}
          />
        </Form.Group>
        <Form.Group
          className="input input-md date-input"
          controlId={`${column.columnDef.header}-to`}
        >
          <Form.Label>
            {column.columnDef?.filterInputInfo?.label ||
              column.columnDef.header}{" "}
            إلى
          </Form.Label>
          <Form.Control
            ref={filterRef}
            type="date"
            value={columnFilterValue?.[1] || ""}
            onChange={(e) => {
              column.setFilterValue((old) => [old?.[0] || "", e.target.value]);
              if (extraProcess)
                extraProcess({
                  column,
                  headers,
                  filterRef,
                  newValue: e.target.value,
                });
            }}
          />
        </Form.Group>
      </div>
    );
  if (column.columnDef?.filterInputInfo?.type === "numberPeriod")
    return (
      <div className="table__filter__period">
        <Form.Group
          className="input input-md"
          controlId={`${column.columnDef.header}-from`}
        >
          <Form.Label>
            {column.columnDef?.filterInputInfo?.label ||
              column.columnDef.header}{" "}
            من
          </Form.Label>
          <Form.Control
            ref={filterRef}
            type="number"
            value={columnFilterValue?.[0] || ""}
            onChange={(e) => {
              column.setFilterValue((old) => [
                Number(e.target.value),
                old?.[1] || "",
              ]);
              if (extraProcess)
                extraProcess({
                  column,
                  headers,
                  filterRef,
                  newValue: e.target.value,
                });
            }}
          />
        </Form.Group>
        <Form.Group
          className="input input-md"
          controlId={`${column.columnDef.header}-to`}
        >
          <Form.Label>
            {column.columnDef?.filterInputInfo?.label ||
              column.columnDef.header}{" "}
            إلى
          </Form.Label>
          <Form.Control
            ref={filterRef}
            type="number"
            value={columnFilterValue?.[1] || ""}
            onChange={(e) => {
              column.setFilterValue((old) => [
                old?.[0] || "",
                e.target.value ? Number(e.target.value) : "",
              ]);
              if (extraProcess)
                extraProcess({
                  column,
                  headers,
                  filterRef,
                  newValue: e.target.value,
                });
            }}
          />
        </Form.Group>
      </div>
    );

  return null;
}
function Table(props) {
  const {
    columns,
    data,
    exportName,
    exportHeaders,
    printable,
    headerTitle,
    datePeriodHeaderToUseAtHeader,
    printDateHeaderArr,
    printerName,
    sum,
    sumTitle,
  } = props;
  const tableRef = useRef();
  const [auth, dispatchAuth] = useAuth();
  
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    filterFns: {
      // (row: Row<TData>, columnId: string, filterValue: any, addMeta: (meta: FilterMeta) => void): boolean;

      includesString: (rows, columnId, filterValue) => {
        const rowValue = rows.original[columnId];
        if (rowValue == null) return false; // If the value is null or undefined, exclude the row
        return filterFns.includesString(rows, columnId, filterValue); // Use the default filter function for strings after converting null/undefined to empty strings
      },
      datePeriod: (rows, columnIds, filterValue) => {
        const rowDate = new Date(rows.original[columnIds]).getTime();
        const fromDate = new Date(filterValue[0]).getTime();
        const toDate = new Date(filterValue[1]).getTime();
        // if we don't have any value to compare return
        if ((!fromDate && !toDate) || !rows.original[columnIds]) return true;
        // only "from" input case
        if (fromDate && !toDate && rowDate >= fromDate) {
          return true;
        }
        // only "to" input case
        if (!fromDate && toDate && rowDate <= toDate) {
          return true;
        }
        // period input cases
        // if user entered inputs in opposite order
        if (
          fromDate &&
          toDate &&
          toDate < fromDate &&
          rowDate <= fromDate &&
          rowDate >= toDate
        ) {
          return true;
        }
        // if user entered right inputs
        if (fromDate && toDate && rowDate <= toDate && rowDate >= fromDate) {
          return true;
        }

        return false;
      },
      customEqual: (rows, columnIds, filterValue) => {
        if (!filterValue) return true;
        const rowValue = rows.original[columnIds];
        // if found the value then return true
        // eslint-disable-next-line eqeqeq
        if (filterValue == rowValue) return true;
        // else
        return false;
      },
    },
  });

  // printHeaderValue how it Looks
  // ["2023-03-02", ""];
  // or it can be undefined
  const localPrintDateHeaderArr = useMemo(
    () =>
      (() => {
        const arrOfDate = table.options.state.columnFilters.find(
          (item) => item.id === datePeriodHeaderToUseAtHeader
        );
        return arrOfDate?.value;
      })(),
    [table.options.state.columnFilters, datePeriodHeaderToUseAtHeader]
  );
  const [, loadingDispatch] = useLoading();

  const [printDate, setPrintDate] = useState(fullDateWithDetails());

  const handlePrint = useReactToPrint({
    
    content: () => tableRef.current,
    onBeforeGetContent: async () => {
      handleLoading(loadingDispatch, true);      
      setPrintDate(fullDateWithDetails());
      table.setPageSize(1e10);
      setTimeout(() => {}, 1000);
    },
    onAfterPrint: async() => {

      handleLoading(loadingDispatch, false);
      table.setPageSize(10);
    },
  });

  const createXlsx = async() => {
    // create a new workbook;
    await addNewLog({
      ipAddress: auth.ipAddress,
      hostname: auth.hostname,
      logDescription: `${generateTextFromJson({},` تصدير أكسل ${headerTitle}`)}`
    });    
        
    const jsonArr = JSON.parse(JSON.stringify(data));
    // show only the common fields in the xls by finding non intersect keys then  delete the not found keys
    const notIntersectKeysBetweenHeadersAndData = getNotIntersection(
      Object.keys(jsonArr.length ? jsonArr[0] : []),
      Object.keys(exportHeaders)
    );
    // delete not found keys
    if (notIntersectKeysBetweenHeadersAndData.length) {
      jsonArr.forEach((item) => {
        notIntersectKeysBetweenHeadersAndData.forEach(
          // eslint-disable-next-line no-param-reassign
          (intersected) => delete item[intersected]
        );
      });
    }
    // get the keys of the json not use them to match the right order of the headers
    const jsonKeys = Object.keys(jsonArr[0]);
    const headerKeys = [];
    //
    jsonKeys.forEach((key) => headerKeys.push(exportHeaders[key]));
    const workbook = utils.book_new();

    // create a new worksheet
    const worksheet = utils.json_to_sheet(jsonArr, {
      origin: "A2",
      skipHeader: true,
    });

    utils.sheet_add_aoa(worksheet, [headerKeys], {
      origin: "A1",
    });
    // add the worksheet to the workbook
    utils.book_append_sheet(workbook, worksheet /* , "Sheet1" */);

    // save the workbook as an Excel file
    writeFile(workbook, `${exportName}.xlsx` || "myExcelFile.xlsx");
  };

  return (
    <div className="table_container">
      {data && (
        <>
          <div className="table__filter">
            {table
              .getHeaderGroups()
              .map((headerGroup) =>
                headerGroup.headers.map((header) => (
                  <Filter
                    key={header.column.id}
                    column={header.column}
                    header={header}
                    headers={headerGroup.headers}
                  />
                ))
              )}
          </div>
          {(exportHeaders || printable) && (
            <div className="table__exports mt-3">
              {exportHeaders && table.getRowModel().rows?.length ? (
                <button
                  type="button"
                  className="table__export btn btn--primary"
                  onClick={createXlsx}
                >
                  <i
                    className="fa-solid fa-file-arrow-down clickable"
                    key="export"
                  />
                </button>
              ) : null}

              {printable && (
                <button
                  type="button"
                  className="table__export btn btn--primary me-2"
                  onClick={ async()=>{handlePrint()
                    await addNewLog({
                      ipAddress: auth.ipAddress,
                      hostname: auth.hostname,
                      logDescription: `${generateTextFromJson({},` طباعة ${headerTitle}`)}`
                    });
              
                  }}
                >
                  <i className="fa-solid fa-print clickable" key="export" />
                </button>
              )}
            </div>
          )}
          {data?.length > 0 && (
            <p className="mt-1">
              عدد الصفوف: {table.getFilteredRowModel().rows.length}
            </p>
          )}
          <div ref={tableRef} className="print-container">
            <div className="print-preview" />
            <div className="table-report-header">
              <img
                src={`${process.env.PUBLIC_URL}/petra_logo_web.svg`}
                alt="logo"
                height={70}
              />
              <h2 className="table-report-title mx-auto">{headerTitle}</h2>

              <div className="grid" style={{ fontSize: ".8rem" }}>
                <p style={{ direction: "ltr" }}>
                  {printDate}
                  <span className="bold ms-2">:وقت الطباعة</span>
                </p>
              </div>
            </div>
            <p className="table-printer-name mt-3">
              <span className="bold ">أنشئ من قبل: </span>
              {printerName}
            </p>
            {(localPrintDateHeaderArr || printDateHeaderArr) && (
              <TableReportDataPeriod
                dateArr={localPrintDateHeaderArr || printDateHeaderArr}
              />
            )}
            <table className="table mt-3">
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th
                        key={header.id}
                        colSpan={header.colSpan}
                        className={header.column.columnDef.cellClass}
                      >
                        {header.isPlaceholder ? null : (
                          <div>
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                          </div>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className={cell.column.columnDef.cellClass || ""}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
                {table.getRowModel().rows.length === 0 ? (
                  <tr className="text-center">
                    <td colSpan="100%">لا يوجد بيانات لعرضها</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
            {sum && (
              <div className="grid grid-of-3 mt-2">
                {sum && (
                  <div className="bold">
                    {sumTitle}: {sum}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="pagination">
            <button
              type="button"
              onClick={() => table.setPageIndex(0)}
              disabled={!table.getCanPreviousPage()}
            >
              {"<<"}
            </button>
            <button
              type="button"
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
            >
              {"<"}
            </button>
            {/* indexed buttons */}
            {/* {table.getState().pagination.pageIndex + 3} */}
            {table.getState().pagination.pageIndex < 3 ? (
              <>
                <button
                  type="button"
                  className={
                    table.getState().pagination.pageIndex === 0
                      ? "active"
                      : undefined
                  }
                  onClick={() => table.setPageIndex(0)}
                >
                  1
                </button>
                {table.getPageCount() > 1 && (
                  <button
                    type="button"
                    className={
                      table.getState().pagination.pageIndex === 1
                        ? "active"
                        : undefined
                    }
                    onClick={() => table.setPageIndex(1)}
                  >
                    2
                  </button>
                )}
                {table.getPageCount() > 2 && (
                  <button
                    type="button"
                    className={
                      table.getState().pagination.pageIndex === 2
                        ? "active"
                        : undefined
                    }
                    onClick={() => table.setPageIndex(2)}
                  >
                    3
                  </button>
                )}
                {table.getPageCount() > 3 && (
                  <button type="button" onClick={() => table.setPageIndex(3)}>
                    4
                  </button>
                )}
                {table.getPageCount() > 4 && (
                  <button type="button" onClick={() => table.setPageIndex(4)}>
                    5
                  </button>
                )}
              </>
            ) : table.getPageCount() -
                (table.getState().pagination.pageIndex + 1) <
              3 ? (
              <>
                {/* table.setPageIndex(0) */}
                <button
                  type="button"
                  onClick={() => table.setPageIndex(table.getPageCount() - 5)}
                >
                  {table.getPageCount() - 4}
                </button>
                <button
                  type="button"
                  onClick={() => table.setPageIndex(table.getPageCount() - 4)}
                >
                  {table.getPageCount() - 3}
                </button>
                <button
                  type="button"
                  className={
                    table.getState().pagination.pageIndex ===
                    table.getPageCount() - 3
                      ? "active"
                      : undefined
                  }
                  onClick={() => table.setPageIndex(table.getPageCount() - 3)}
                >
                  {table.getPageCount() - 2}
                </button>
                <button
                  type="button"
                  className={
                    table.getState().pagination.pageIndex ===
                    table.getPageCount() - 2
                      ? "active"
                      : undefined
                  }
                  onClick={() => table.setPageIndex(table.getPageCount() - 2)}
                >
                  {table.getPageCount() - 1}
                </button>
                <button
                  type="button"
                  className={
                    table.getState().pagination.pageIndex ===
                    table.getPageCount() - 1
                      ? "active"
                      : undefined
                  }
                  onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                >
                  {table.getPageCount()}
                </button>
              </>
            ) : (
              [...Array(5).keys()].map((index) => {
                const { pageIndex } = table.getState().pagination;

                if (index === 0)
                  return (
                    <button
                      type="button"
                      onClick={() => table.setPageIndex(pageIndex - 2)}
                    >
                      {pageIndex - 1}
                    </button>
                  );
                if (index === 1)
                  return (
                    <button
                      type="button"
                      onClick={() => table.setPageIndex(pageIndex - 1)}
                    >
                      {pageIndex}
                    </button>
                  );
                if (index === 2)
                  return (
                    <button
                      type="button"
                      className="active"
                      onClick={() => table.setPageIndex(pageIndex)}
                    >
                      {pageIndex + 1}
                    </button>
                  );
                if (index === 3)
                  return (
                    <button
                      type="button"
                      onClick={() => table.setPageIndex(pageIndex + 1)}
                    >
                      {pageIndex + 2}
                    </button>
                  );
                if (index === 4)
                  return (
                    <button
                      type="button"
                      onClick={() => table.setPageIndex(pageIndex + 2)}
                    >
                      {pageIndex + 3}
                    </button>
                  );
                return null;
              })
            )}
            {/* end indexed buttons */}
            <button
              type="button"
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
            >
              {">"}
            </button>
            <button
              type="button"
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              disabled={!table.getCanNextPage()}
            >
              {">>"}
            </button>
          </div>
          <div
            className="d-flex"
            style={{
              justifyContent: "center",
            }}
          >
            <div>
              <strong>
                <span style={{ marginInlineStart: "5px" }}>Page</span>
                {table.getState().pagination.pageIndex + 1} of{" "}
                {table.getPageCount()}
              </strong>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

Table.defaultProps = {
  isPagination: true,
  printable: false,
  exportName: "جدول",
  headerTitle: "",
  datePeriodHeaderToUseAtHeader: "",
  printerName: "",
  printDateHeaderArr: undefined,
  sum: undefined,
  sumTitle: "المجموع",
};

Table.prototype = {
  headers: PropTypes.array.isRequired,
  tableData: PropTypes.array.isRequired,
  setExportData: PropTypes.func.isRequired,
  isPagination: PropTypes.bool,
  printable: PropTypes.bool,
  exportName: PropTypes.string,
  exportHeaders: PropTypes.object,
  headerTitle: PropTypes.string,
  datePeriodHeaderToUseAtHeader: PropTypes.string,
  printDateHeaderArr: PropTypes.array,
  printerName: PropTypes.string,
  sum: PropTypes.number,
  sumTitle: PropTypes.string,
};
export default Table;
